import { z } from 'zod';
import { TabelaComissaoSobre, TabelaComissaoTipo } from './enum';
import { TabelaComissaoProdutoPartialSchema } from './TabelaComissaoProdutoPartial';

const TabelaComissaoExcecaoSchema = z.object({
    produto: TabelaComissaoProdutoPartialSchema,
    tce_idpk: z.number(),
    tce_percentual: z.number(),
    tce_produto_idpk: z.number(),
    tce_ultima_alteracao: z.string().nullable(),
});

export type TabelaComissaoExcecao = z.infer<typeof TabelaComissaoExcecaoSchema>;

export const TabelaComissaoSchema = z.object({
    tabela_comissao_excecao: TabelaComissaoExcecaoSchema.array().nullable(),
    tac_calcular_comissao_sobre: z.enum(TabelaComissaoSobre),
    tac_descricao: z.string().nullable(),
    tac_empresa_idpk: z.number(),
    tac_idpk: z.number(),
    tac_percentual: z.number(),
    tac_tipo: z.enum(TabelaComissaoTipo),
    tac_ultima_alteracao: z.string().nullable(),
});

export type TabelaComissao = z.infer<typeof TabelaComissaoSchema>;
